import { BadgeCheck } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";

import ComingSoonDirectory from "./pages/ComingSoonDirectory";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";

const ComingSoonRouter: NavigationLinkProps[] = [
  {
    id: "dff0264a-6960-4a85-87f7-aae1bd5530cc",
    title: "Coming Soon!",
    description: "",
    path: "/coming-soon",
    auth: true,
    sidebar: false,
    secondarySidebar: false,
    icon: BadgeCheck,
    component: ComingSoonDirectory,
    requiredFeature: "ANY",
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.COMING_SOON,
    isFeatureFlagged: true,
  },
];

export default ComingSoonRouter;
